import { LOGO_URL } from "@/config";

// Placeholder tipográfico mientras llega el archivo oficial del logo de SoyDiVa.
// Para usar el logo real basta con asignar su URL a LOGO_URL en src/config.js.
export function BrandLogo({
  imgClassName = "h-14 w-14",
  textClassName = "font-script text-4xl leading-none text-cocoa",
}) {
  if (LOGO_URL) {
    return (
      <img
        src={LOGO_URL}
        alt="Logo de SoyDiVa"
        className={`${imgClassName} rounded-full border border-sand bg-white object-cover`}
        data-testid="brand-logo-img"
      />
    );
  }
  return (
    <span className={textClassName} data-testid="brand-logo">
      SoyDiVa
    </span>
  );
}
